import React from "react";
import PropTypes from "prop-types";
import { Row } from "components/Containers";
import { css } from "@emotion/react";
import { useSignupForm } from "hooks";
import { colors, fontSize } from "style";
import { FormattedMessage } from "react-intl";
import FormEmail from "./FormEmail";
import SignupComplete from "./SignupComplete";

/**
 * RoleSignupForms
 *
 * Single-step signup. Titled with the role when applying for one.
 *
 * @param {Object}    role
 * @param {Function}  onSignupCompleted
 */
const RoleSignupForms = ({ role, onSignupCompleted, ...props }) => {
  const { formData, handleFormChange, signupCompleted, setSignupCompleted } = useSignupForm({ onSignupCompleted });

  if (signupCompleted) {
    return <SignupComplete formData={formData} />;
  }

  return (
    <>
      <Row css={styles.container}>
        <span css={styles.title}>
          {role ? (
            <FormattedMessage id="Signup.RoleSignupForms.Title" values={{ role: role.name }} />
          ) : (
            <FormattedMessage id="Signup.SignupForms.Title" />
          )}
        </span>
      </Row>
      <div css={styles.container}>
        <FormEmail
          isSingleStep
          titleId={role ? "Signup.FormRoleEmail.FormLabelTitle" : "Signup.FormSingleStepEmail.FormLabelTitle"}
          values={formData}
          onChange={handleFormChange}
          onCompleted={() => setSignupCompleted(true)}
          {...props}
        />
      </div>
    </>
  );
};

const styles = {
  container: css`
    justify-content: space-between;
    margin-bottom: 1.5rem;
  `,
  title: css`
    color: ${colors.black};
    font-size: ${fontSize.xxlarge};
    font-weight: 700;
  `,
};

RoleSignupForms.propTypes = {
  role: PropTypes.object,
  onSignupCompleted: PropTypes.func,
};

export default RoleSignupForms;
